/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

    interface IMeevoIFrameLoadScope extends ng.IScope {
        callBack(): void;
    }

    export class MeevoIFrameLoad implements angular.IDirective {
        restrict = 'A';
        scope = {
            callBack: '&meevoIFrameLoad'
        };

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoIFrameLoad();
            };

            return directive;
        }

        link(scope: IMeevoIFrameLoadScope, element: JQuery) {
            element.on('load', function () {
                return scope.callBack();
            })
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoIFrameLoad', MeevoIFrameLoad.factory());
}